import React from 'react';
import Input from 'atoms/Input/Input';
import Search from 'app/icons/Monospaced/Search/Search';
import { InputContainer } from './InputSearch.styles';
import Button from 'atoms/Button/Button';

interface InputSearchProps {
  search: string;
  onChange: (search: string) => void;
  onSearch: () => void;
}

const InputSearch = ({ search, onChange, onSearch }: InputSearchProps): JSX.Element => {
  const handleEnterKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <InputContainer className='input-search'>
      <Input
        placeholder='Search'
        type='text'
        value={search}
        size='md'
        onChange={onChange}
        leftElement={
          <Button
            size='sm'
            variant='text-link'
            className='search-button'
            icon={<Search width={20} />}
            onClick={onSearch}
          />
        }
        onKeyDown={handleEnterKeyPress}
      />
    </InputContainer>
  );
};

export default InputSearch;
